import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const KEY = "argov_cookie_ack_v1";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    try { if (!localStorage.getItem(KEY)) setVisible(true); } catch { /* noop */ }
  }, []);
  const ack = () => {
    try { localStorage.setItem(KEY, String(Date.now())); } catch { /* noop */ }
    setVisible(false);
  };
  if (!visible) return null;
  return (
    <div style={{ position: "fixed", left: 20, right: 20, bottom: 20, zIndex: 200, display: "flex", justifyContent: "center", pointerEvents: "none" }}>
      <div style={{ pointerEvents: "auto", maxWidth: 720, background: "#0c1a2e", color: "#e2e8f0", border: "1px solid rgba(8,145,178,0.35)", borderRadius: 12, padding: "14px 18px", display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap", boxShadow: "0 12px 40px rgba(0,0,0,0.25)" }}>
        <span className="argov-pulse" style={{ width: 8, height: 8, borderRadius: "50%", background: "#0891b2", flexShrink: 0 }} />
        <p style={{ fontSize: 13, lineHeight: 1.55, flex: 1, minWidth: 220 }}>
          <strong style={{ color: "#fff" }}>Cookies.</strong> ARGOV uses only strictly-necessary cookies to keep the CRM session secure. We do not use tracking or advertising cookies. Read the <Link to="/cookies" style={{ color: "#4db8ff" }}>Cookie Policy</Link>.
        </p>
        <button data-testid="cookie-ack-btn" onClick={ack} style={{ background: "#0891b2", color: "#fff", border: "none", borderRadius: 8, padding: "8px 18px", fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: "'DM Sans', sans-serif" }}>Got it</button>
      </div>
    </div>
  );
};
